// src/hooks/useTypewriter.js
import { useState, useEffect } from "react";

const useTypewriter = (words, speed = 150, delay = 2000) => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [typedText, setTypedText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const handleTyping = () => {
      const currentWord = words[currentWordIndex];
      const updatedText = isDeleting
        ? currentWord.substring(0, typedText.length - 1)
        : currentWord.substring(0, typedText.length + 1);

      setTypedText(updatedText);

      if (!isDeleting && updatedText === currentWord) {
        setTimeout(() => setIsDeleting(true), delay);
      } else if (isDeleting && updatedText === "") {
        setIsDeleting(false);
        setCurrentWordIndex((prev) => (prev + 1) % words.length);
      }
    };

    const typingTimeout = setTimeout(
      handleTyping,
      isDeleting ? speed / 2 : speed
    );
    return () => clearTimeout(typingTimeout);
  }, [typedText, isDeleting, words, speed, delay, currentWordIndex]);

  return typedText;
};

export default useTypewriter;
